<!-- 楽天用ので現在使われていないため修正しません -->
<template>
  <v-container class="mt-4">
    <v-row v-resize="onResize">
      <v-col :cols="isMobile ? 12 : 10" offset-xs>
        <h1 class="mb-3" :class="{ 'text-h6': isMobile, 'text-h5': !isMobile }" v-html="$t('cpmCreativeReport.title')"></h1>
      </v-col>
      <v-col class="text-right" :cols="isMobile ? 12 : 2">
        <v-btn color="light-blue darken-1 text-white" @click="clickCampaignList()">{{ $t('cpmCreativeReport.buttonCampaignPeriod') }}</v-btn>
      </v-col>
      <v-col xs12 offset-xs v-if="errorMessage">
        <v-alert :value="true" type="error" v-html="$t(errorMessage)"></v-alert>
      </v-col>
      <v-col md3 xs12 offset-xs>
        <div>
          <span class="v-label v-label--active theme--light" style="left: 0px; right: auto">
            {{ $t('commons.filter.calendar.title.aggregateDateRange') }}
          </span>
          <br />
          <VueDatePicker
            ref="picker"
            :opens="opens"
            :locale-data="{
              direction: 'ltr',
              format: 'yyyy/mm/dd',
              separator: ' - ',
              weekLabel: '',
              customRangeLabel: 'Custom Range',
              daysOfWeek: $t('commons.filter.calendar.daysOfWeek'),
              firstDay: 1
            }"
            :ranges="ranges"
            :singleDatePicker="false"
            :showWeekNumbers="true"
            v-model="dateRange"
            :linkedCalendars="false"
            :minDate="minDate" :maxDate="maxDate"
            :showDropdowns="false"
            :autoApply="false"
            :month-change-on-scroll="false"
          >
            <!--    input slot (new slot syntax)-->
            <template #input="picker" style="min-width: 350px"
              >{{ formatDisplayDate(picker.startDate) }} - {{ formatDisplayDate(picker.endDate) }}</template
            >
            <!--    ranges (new slot syntax) -->
            <template #ranges="ranges">
              <div class="ranges" style="float: left">
                <ul>
                  <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                    <b>{{ name }}</b>
                  </li>
                </ul>
              </div>
            </template>
            <!--    footer slot-->
            <div slot="footer" slot-scope="data" class="slot">
              <div></div>
              <div style="margin-left: auto">
                <v-btn color="light-green darken-1 text-white" @click="data.clickApply" v-if="!data.in_selection">{{ $t('commons.global.button.select') }}</v-btn>
                <v-btn color="darken-1" @click="data.clickCancel" v-if="!data.in_selection">{{ $t('commons.global.button.cancel') }}</v-btn>
              </div>
            </div>
          </VueDatePicker>
        </div>
      </v-col>
      <v-col md9 xs12 offset-xs>
        <MultiSelect
          v-model:select-items="campaignIdsComputed"
          :items="campaignList"
          item-title="campaignName"
          item-value="campaignId"
          :label="$t('cpmCreativeReport.filter.multiSelect.title.campaign')"
          :no-data-text="$t('commons.form.select.notfound')"
          :rules="[campaignIdsComputed.length !== 0 || $t('cpmCreativeReport.filter.multiSelect.noSelection')]"
          :required="true"
          style="white-space: nowrap;"
        />
      </v-col>
      <v-col md3 xs6 offset-xs>
        <MultiSelect
          v-model:select-items="creativeTypeIdsComputed"
          :items="creativeTypeList"
          item-title="creativeTypeName"
          item-value="creativeTypeId"
          :label="$t('cpmCreativeReport.filter.multiSelect.title.creativeType')"
          :no-data-text="$t('commons.form.select.notfound')"
          :rules="[creativeTypeIdsComputed.length !== 0 || $t('cpmCreativeReport.filter.multiSelect.noSelection')]"
          :required="true"
          style="white-space: nowrap;"
        />
      </v-col>
      <v-col md2 xs6 offset-xs>
        <MultiSelect
          v-model:select-items="creativeSizeIdsComputed"
          :items="creativeSizeList"
          item-title="creativeSizeName"
          item-value="creativeSizeId"
          :label="$t('cpmCreativeReport.filter.multiSelect.title.size')"
          :no-data-text="$t('commons.form.select.notfound')"
          :rules="[creativeSizeIdsComputed.length !== 0 || $t('cpmCreativeReport.filter.multiSelect.noSelection')]"
          :required="true"
        />
      </v-col>
      <v-col md6 xs12 offset-xs>
        <v-text-field v-model="creativeName" :label="$t('cpmCreativeReport.inputLabelCreative')" maxlength="100"></v-text-field>
      </v-col>
      <v-col md1 xs12 class="text-right" offset-xs>
        <v-btn color="blue-grey darken-4 text-white" @click="search()" :disabled="isDisabledBtn">{{ $t('commons.global.button.search') }}</v-btn>
      </v-col>
    </v-row>
    <v-row justify-center class="mt-3">
      <v-col x12>
        <div class="mb-2" :class="{ title: !isMobile, subheading: isMobile }">{{ $t('cpmCreativeReport.table.totalTitle') }}</div>
        <v-data-table
          :headers="totalHeaders"
          :items="totalReport"
          :hide-default-header="isMobile"
          hide-default-footer
          :no-data-text="$t('commons.table.no.data.text')"
          class="elevation-3 total-list text-no-wrap"
          :class="{ mobile: isMobile }"
          :loading="isSearching"
        >
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="text-right break-word-cell">{{ number_format(props.item.imp) }}</td>
              <td class="text-right break-word-cell">{{ props.item.cpm | number_format_yen_fixed_decimal }}</td>
              <td class="text-right break-word-cell">{{ number_format(props.item.click) }}</td>
              <td class="text-right break-word-cell">{{ props.item.cpc | number_format_yen_fixed_decimal }}</td>
              <td class="text-right break-word-cell">{{ props.item.ctr | percent_format_cpm }}</td>
              <td class="text-right break-word-cell">{{ props.item.digestiveAmount | digestive_format }}</td>
              <td class="text-right break-word-cell">{{ number_format(props.item.cv) }}</td>
              <td class="text-right break-word-cell">{{ props.item.cpa | number_format_yen_fixed_decimal }}</td>
              <td class="text-right break-word-cell">{{ props.item.cvr | percent_format_cpm }}</td>
              <td class="text-right break-word-cell">{{ props.item.vcv | number_format }}</td>
              <!-- is VideoAdsReport -->
              <td v-if="isNotEmptyVideoAds(props.item.videoReport, 'playCount')" class="text-right">{{ props.item.videoReport.playCount | number_format }}</td>
              <td v-if="isNotEmptyVideoAds(props.item.videoReport, 'firstQuartileCount')" class="text-right">{{ props.item.videoReport.firstQuartileCount | number_format }}</td>
              <td v-if="isNotEmptyVideoAds(props.item.videoReport, 'midpointCount')" class="text-right">{{ props.item.videoReport.midpointCount | number_format }}</td>
              <td v-if="isNotEmptyVideoAds(props.item.videoReport, 'thirdQuartileCount')" class="text-right">{{ props.item.videoReport.thirdQuartileCount | number_format }}</td>
              <td v-if="isNotEmptyVideoAds(props.item.videoReport, 'completeCount')" class="text-right">{{ props.item.videoReport.completeCount | number_format }}</td>
              <td v-if="isNotEmptyVideoAds(props.item.videoReport, 'cpcv')" class="text-right">{{ props.item.videoReport.cpcv | number_format_yen_fixed_decimal }}</td>
              <!-- not VideoAdsReport -->
              <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'playCount')" class="text-center"> - </td>
              <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'firstQuartileCount')" class="text-center"> - </td>
              <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'midpointCount')" class="text-center"> - </td>
              <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'thirdQuartileCount')" class="text-center"> - </td>
              <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'completeCount')" class="text-center"> - </td>
              <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'cpcv')" class="text-center"> - </td>
            </tr>
            <tr v-else>
              <td>
                <ul class="flex-content">
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.imp')">{{ number_format(props.item.imp) }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.cpm')">{{ props.item.cpm | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.click')">{{ number_format(props.item.click) }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.cpc')">{{ props.item.cpc | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.ctr')">{{ props.item.ctr | percent_format_cpm }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.digestiveAmount')">{{ props.item.digestiveAmount | digestive_format }}</li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.cv')">{{ number_format(props.item.cv) }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.cpa')">{{ props.item.cpa | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.cvr')">{{ props.item.cvr | percent_format_cpm }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.vcv')">{{ props.item.vcv | number_format }}</li>
                  <!-- is VideoAdsReport -->
                  <li v-if="isNotEmptyVideoAds(props.item.videoReport, 'playCount')"  class="flex-item3" :data-label="$t('campaignReport.total.headers.playCount')">{{ props.item.videoReport.playCount | number_format }}</li>
                  <li v-if="isNotEmptyVideoAds(props.item.videoReport, 'firstQuartileCount')"  class="flex-item4" :data-label="$t('campaignReport.total.headers.firstQuartileCount')">{{ props.item.videoReport.firstQuartileCount | number_format }}</li>
                  <li v-if="isNotEmptyVideoAds(props.item.videoReport, 'midpointCount')"  class="flex-item3" :data-label="$t('campaignReport.total.headers.midpointCount')">{{ props.item.videoReport.midpointCount | number_format }}</li>
                  <li v-if="isNotEmptyVideoAds(props.item.videoReport, 'thirdQuartileCount')"  class="flex-item4" :data-label="$t('campaignReport.total.headers.thirdQuartileCount')">{{ props.item.videoReport.thirdQuartileCount | number_format }}</li>
                  <li v-if="isNotEmptyVideoAds(props.item.videoReport, 'completeCount')"  class="flex-item3" :data-label="$t('campaignReport.total.headers.completeCount')">{{ props.item.videoReport.completeCount | number_format }}</li>
                  <li v-if="isNotEmptyVideoAds(props.item.videoReport, 'cpcv')"  class="flex-item4" :data-label="$t('campaignReport.total.headers.cpcv')">{{ props.item.videoReport.cpcv | number_format_yen_fixed_decimal }}</li>
                  <!-- not VideoAdsReport -->
                  <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'playCount')" class="flex-item3"> - </td>
                  <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'firstQuartileCount')" class="flex-item4"> - </td>
                  <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'midpointCount')" class="flex-item3"> - </td>
                  <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'thirdQuartileCount')" class="flex-item4"> - </td>
                  <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'completeCount')" class="flex-item3"> - </td>
                  <td v-if="!isNotEmptyVideoAds(props.item.videoReport, 'cpcv')" class="flex-item4"> - </td>
                </ul>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify-left class="mt-3">
      <v-col xs12 class="text-right">
        <v-btn color="light-green darken-1 text-white" :disabled="isDisabledCsvDownloadBtn" @click="clickDownload()">
          <v-icon>get_app</v-icon>
          {{ $t('cpmCreativeReport.table.download') }}
        </v-btn>
        <div class="caption text-red-accent-4">{{ $t('cpmCreativeReport.table.infoMessage') }}</div>
      </v-col>
    </v-row>
    <v-row justify-center>
      <v-col xs12>
        <v-data-table
          :headers="reportHeaders"
          :items="creativeReport"
          hide-default-header
          hide-default-footer
          :server-items-length="totalCreative"
          :sort-by="pagination.sortBy"
          :sortDesc="pagination.descending"
          :items-per-page="pagination.rowsPerPage"
          :no-data-text="$t('commons.table.no.data.text')"
          class="elevation-3 report-list"
          :class="{ mobile: isMobile }"
          :loading="isSearching"
        >
          <template v-slot:header="{ props }">
            <thead class="v-data-table-header">
              <tr v-if="!isMobile">
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :width="header.width"
                  :class="[
                    'column nowrap',
                    header.sortable != false ? 'sortable' : '',
                    'text-center',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : ''
                  ]"
                  @click="header.sortable !== false ? changeSort(header.value) : null"
                >
                  {{ header.text }}
                  <v-icon v-if="header.sortable" class="v-data-table-header__icon" small>mdi-arrow-up</v-icon>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="text-left break-word-cell">{{ props.item.creativeName }}</td>

              <td v-if="props.item.creativeType == 8" class="text-center">
                <img
                  v-bind:src="props.item.thumbnail"
                  style="margin-top: 3px; max-width: 120px; max-height: 90px"
                  v-on:click="previewDialog(props.item.consoleCreativeId, props.item.preview, props.item.creativeSize)"
                />
                <br />
                <v-btn
                  style="height: 25px; text-transform: capitalize"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewDialog(props.item.consoleCreativeId, props.item.preview, props.item.creativeSize)"
                  >Preview</v-btn
                >
              </td>
              <td v-else-if="props.item.creativeType == 10" class="text-center">
                <img
                  v-bind:src="props.item.thumbnail"
                  v-on:click="previewCkickOpenWindow(props.item.consoleCreativeId, props.item.preview)"
                  style="margin-top: 3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height: 25px; text-transform: capitalize"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewCkickOpenWindow(props.item.consoleCreativeId, props.item.preview)"
                >
                  <v-icon style="height: 20px;font-size:15px;">open_in_new</v-icon>
                  Play
                </v-btn>
              </td>
              <td v-else-if="props.item.creativeType == 4" class="text-center">
                <img
                  v-on:click="previewDialog(props.item.consoleCreativeId, convertDynamicCreative(props.item.preview), props.item.creativeSize)"
                  v-bind:src="props.item.thumbnail"
                  style="margin-top: 3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height: 25px; text-transform: capitalize"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewDialog(props.item.consoleCreativeId, convertDynamicCreative(props.item.preview), props.item.creativeSize)"
                  >Preview</v-btn
                >
              </td>
              <td v-else-if="props.item.creativeType == 5 || props.item.creativeType == 6" class="text-center">
                <img
                  v-on:click="
                    previewDialog(props.item.consoleCreativeId, props.item.preview, '300x350', $t('submissionConfirmationCreativeSetting.dialog.notes'))
                  "
                  v-bind:src="props.item.thumbnail"
                  style="margin-top: 3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height: 25px; text-transform: capitalize"
                  color="light-gray darken-1 black--text"
                  v-on:click="
                    previewDialog(props.item.consoleCreativeId, props.item.preview, '300x350', $t('submissionConfirmationCreativeSetting.dialog.notes'))
                  "
                  >Preview</v-btn
                >
              </td>
              <td v-else-if="props.item.creativeType == 1" class="text-center">
                <img
                  v-on:click="previewResizeDialog(props.item.consoleCreativeId, props.item.preview, props.item.creativeSize)"
                  v-bind:src="props.item.thumbnail"
                  style="margin-top: 3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height: 25px; text-transform: capitalize"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewResizeDialog(props.item.consoleCreativeId, props.item.preview, props.item.creativeSize)"
                  >Preview</v-btn
                >
              </td>
              <td v-else-if="props.item.creativeType == 13" class="text-center">
                <img
                  v-if="props.item.thumbnail != null"
                  v-on:click="previewDialog(props.item.consoleCreativeId, props.item.preview, props.item.creativeSize)"
                  v-bind:src="props.item.thumbnail"
                  style="margin-top: 3px; max-width: 120px; max-height: 90px"
                />
                <span v-if="props.item.thumbnail == null">
                  {{ $t('cpmCreativeReport.table.thumbnailInPreparation') }}
                </span>
                <br />
                <v-btn
                  style="height: 25px; text-transform: capitalize"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewDialog(props.item.consoleCreativeId, props.item.preview, props.item.creativeSize)"
                  >Preview</v-btn
                >
              </td>
              <td v-else class="text-center">
                <img
                  v-on:click="previewDialog(props.item.consoleCreativeId, props.item.preview, props.item.creativeSize)"
                  v-bind:src="props.item.thumbnail"
                  style="margin-top: 3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height: 25px; text-transform: capitalize"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewDialog(props.item.consoleCreativeId, props.item.preview, props.item.creativeSize)"
                  >Preview</v-btn
                >
              </td>
              <td class="text-center break-word-cell">{{ props.item.creativeSize }}</td>
              <td class="text-center break-word-cell">{{ props.item.creativeTypeName }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.imp | number_format }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.cpm | number_format_yen_fixed_decimal }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.click | number_format }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.cpc | number_format_yen_fixed_decimal }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.ctr | percent_format_cpm }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.digestiveAmount | digestive_format }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.cv | number_format }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.cpa | number_format_yen_fixed_decimal }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.cvr | percent_format_cpm }}</td>
              <td class="text-right break-word-cell">{{ props.item.report.vcv | number_format }}</td>
              <!-- is VideoAdsReport -->
              <td v-if="isVideoAdsReport(props.item.report.videoReport)" class="text-right">{{ props.item.report.videoReport.playCount | number_format }}</td>
              <td v-if="isVideoAdsReport(props.item.report.videoReport)" class="text-right">{{ props.item.report.videoReport.firstQuartileCount | number_format }}</td>
              <td v-if="isVideoAdsReport(props.item.report.videoReport)" class="text-right">{{ props.item.report.videoReport.midpointCount | number_format }}</td>
              <td v-if="isVideoAdsReport(props.item.report.videoReport)" class="text-right">{{ props.item.report.videoReport.thirdQuartileCount | number_format }}</td>
              <td v-if="isVideoAdsReport(props.item.report.videoReport)" class="text-right">{{ props.item.report.videoReport.completeCount | number_format }}</td>
              <td v-if="isVideoAdsReport(props.item.report.videoReport)" class="text-right">{{ props.item.report.videoReport.cpcv | number_format_yen_fixed_decimal }}</td>
              <!-- not VideoAdsReport -->
              <td v-if="!isVideoAdsReport(props.item.report.videoReport)" class="text-center"> - </td>
              <td v-if="!isVideoAdsReport(props.item.report.videoReport)" class="text-center"> - </td>
              <td v-if="!isVideoAdsReport(props.item.report.videoReport)" class="text-center"> - </td>
              <td v-if="!isVideoAdsReport(props.item.report.videoReport)" class="text-center"> - </td>
              <td v-if="!isVideoAdsReport(props.item.report.videoReport)" class="text-center"> - </td>
              <td v-if="!isVideoAdsReport(props.item.report.videoReport)" class="text-center"> - </td>
            </tr>
            <tr v-else>
              <td>
                <ul class="flex-content">
                  <li class="flex-item word-break" :data-label="$t('cpmCreativeReport.table.headers.creativeName')">{{ props.item.creativeName }}</li>
                  <li v-if="props.item.creativeType == 13" class="flex-item" :data-label="$t('cpmCreativeReport.table.headers.thumbnail')">
                    <span v-if="props.item.thumbnail == null">
                      {{ $t('cpmCreativeReport.table.thumbnailInPreparation') }}
                    </span>
                    <img v-else v-bind:src="props.item.thumbnail" style="margin-top: 3px; max-width: 120px; max-height: 90px" />
                  </li>
                  <li v-else class="flex-item" :data-label="$t('cpmCreativeReport.table.headers.thumbnail')">
                    <img v-bind:src="props.item.thumbnail" style="margin-top: 3px; max-width: 120px; max-height: 90px" />
                  </li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.creativeSize')">{{ props.item.creativeSize }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.creativeType')">{{ props.item.creativeTypeName }}</li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.imp')">{{ props.item.report.imp | number_format }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.cpm')">{{ props.item.report.cpm | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.click')">{{ props.item.report.click | number_format }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.cpc')">{{ props.item.report.cpc | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.ctr')">{{ props.item.report.ctr | percent_format_cpm }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.digestiveAmount')">{{ props.item.report.digestiveAmount | digestive_format }}</li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.cv')">{{ props.item.report.cv | number_format }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.cpa')">{{ props.item.report.cpa | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.cvr')">{{ props.item.report.cvr | percent_format_cpm }}</li>
                  <li class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.vcv')">{{ props.item.report.vcv | number_format }}</li>
                  <!-- is VideoAdsReport -->
                  <li v-if="isVideoAdsReport(props.item.report.videoReport)" class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.playCount')">{{ props.item.report.videoReport.playCount | number_format }}</li>
                  <li v-if="isVideoAdsReport(props.item.report.videoReport)" class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.firstQuartileCount')">{{ props.item.report.videoReport.firstQuartileCount | number_format }}</li>
                  <li v-if="isVideoAdsReport(props.item.report.videoReport)" class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.midpointCount')">{{ props.item.report.videoReport.midpointCount | number_format }}</li>
                  <li v-if="isVideoAdsReport(props.item.report.videoReport)" class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.thirdQuartileCount')">{{ props.item.report.videoReport.thirdQuartileCount | number_format }}</li>
                  <li v-if="isVideoAdsReport(props.item.report.videoReport)" class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.completeCount')">{{ props.item.report.videoReport.completeCount | number_format }}</li>
                  <li v-if="isVideoAdsReport(props.item.report.videoReport)" class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.cpcv')">{{ props.item.report.videoReport.cpcv | number_format_yen_fixed_decimal }}</li>
                  <!-- not VideoAdsReport -->
                  <li v-if="!isVideoAdsReport(props.item.report.videoReport)" class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.playCount')"> - </li>
                  <li v-if="!isVideoAdsReport(props.item.report.videoReport)" class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.firstQuartileCount')"> - </li>
                  <li v-if="!isVideoAdsReport(props.item.report.videoReport)" class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.midpointCount')"> - </li>
                  <li v-if="!isVideoAdsReport(props.item.report.videoReport)" class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.thirdQuartileCount')"> - </li>
                  <li v-if="!isVideoAdsReport(props.item.report.videoReport)" class="flex-item3" :data-label="$t('cpmCreativeReport.table.headers.completeCount')"> - </li>
                  <li v-if="!isVideoAdsReport(props.item.report.videoReport)" class="flex-item4" :data-label="$t('cpmCreativeReport.table.headers.cpcv')"> - </li>
                </ul>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
      <!-- ダイアログ -->
      <div class="preview-pos" v-show="hoverDialogFlag">
        <v-dialog v-model="dialog" :max-width="`${dialogWidth}`">
          <v-card>
            <v-card-actions>
              <div v-html="`${previewImage}`"></div>
            </v-card-actions>
            <v-card-text v-if="description !== ''">
              <span v-html="`${description}`"></span>
            </v-card-text>
            <v-col xs12 class="text-right">
              <v-btn color="green darken-1" text @click.native="dialog = false">Close</v-btn>
            </v-col>
          </v-card>
        </v-dialog>
      </div>
    </v-row>
    <div class="text-center">
      <v-pagination v-model="page" :length="totalPage" :total-visible="10" @input="pageChange" :disabled="isDisabledBtn"></v-pagination>
    </div>
    <v-dialog v-model="warnDlg.isOpen" persistent :max-width="warnDlg.maxWidth">
      <v-card justify="center">
        <v-card-title>
          <v-icon>mdi-alert</v-icon>
          {{ warnDlg.headline }}
        </v-card-title>
        <v-card-text>
          <div style="margin-left: 10px">{{ warnDlg.msg }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="warnDlg.isOpen = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import MultiSelect from './ui/MultiSelect'
export default {
  components: { VueDatePicker, MultiSelect },
  name: 'CreativeReportList',
  props: ['agencyId', 'advertiserId'],
  data: function () {
    return {
      // Data-Table ソート関連
      pagination: {
        // 2重クリック防止用
        isSorting: false,
        sortBy: [{ key: 'creativeType', order:'asc' }],
        descending: false,
        rowsPerPage: -1
      },
      totalCreative: 0,
      // フィルタ：INPUT
      campaignIds: [],
      creativeSizeIds: [],
      creativeTypeIds: [],
      creativeName: '',
      dateRange: {},
      // 初期 or 検索ボタンを押した状態を保持する( DL やページングはこの条件を用いる)
      commiteCampaignIds: [],
      commiteCreativeSizeIds: [],
      commiteCreativeTypeIds: [],
      commiteCreativeName: '',
      commitedateRange: {},
      // 画面描画条件
      opens: 'right',
      ranges: {},
      minDate: '',
      maxDate: '',
      campaignList: [],
      creativeTypeList: [],
      creativeSizeList: [],
      isCampaignAllSelect: false,
      isCreativeTypeAllSelect: false,
      isCreativeSizeAllSelect: false,
      isSearching: false,
      isCsvDownload: false,
      totalHeaders: [
        {title: this.$t('cpmCreativeReport.table.headers.imp'), class: 'text-no-wrap', align: 'left', key: 'imp', sortable: false, width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.cpm'), align: 'left', key: 'cpm', sortable: false, width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.click'), align: 'left', key: 'click', sortable: false, width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.cpc'), align: 'left', key: 'cpc', sortable: false, width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.ctr'), align: 'left', key: 'ctr', sortable: false, width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.digestiveAmount'), align: 'left', key: 'digestiveAmount', sortable: false, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.cv'), align: 'left', key: 'cv', sortable: false, width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.cpa'), align: 'left', key: 'cpa', sortable: false, width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.cvr'), align: 'left', key: 'cvr', sortable: false, width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.vcv'), align: 'left', key: 'vcv', sortable: false, width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.playCount'), align: 'left', sortable: false, key: 'playCount', width: '80'},
        {title: this.$t('cpmCreativeReport.table.headers.firstQuartileCount'), align: 'left', sortable: false, key: 'firstQuartileCount', width: '130'},
        {title: this.$t('cpmCreativeReport.table.headers.midpointCount'), align: 'left', sortable: false, key: 'midpointCount', width: '130'},
        {title: this.$t('cpmCreativeReport.table.headers.thirdQuartileCount'), align: 'left', sortable: false, key: 'thirdQuartileCount', width: '130'},
        {title: this.$t('cpmCreativeReport.table.headers.completeCount'), align: 'left', sortable: false, key: 'completeCount', width: '130'},
        {title: this.$t('cpmCreativeReport.table.headers.cpcv'), align: 'left', sortable: false, key: 'cpcv'}
      ],
      totalReport: [],
      reportHeaders: [
        {title: this.$t('cpmCreativeReport.table.headers.creativeName'), align: 'center', key: 'creativeName', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.thumbnail'), align: 'center', key: 'thumbnail', sortable: false, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.creativeSize'), align: 'center', key: 'creativeSize', sortable: false, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.creativeType'), align: 'center', key: 'creativeType', sortable: true, width: '200'},
        {title: this.$t('cpmCreativeReport.table.headers.imp'), align: 'center', key: 'imp', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.cpm'), align: 'center', key: 'cpm', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.click'), align: 'center', key: 'click', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.cpc'), align: 'center', key: 'cpc', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.ctr'), align: 'center', key: 'ctr', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.digestiveAmount'), align: 'center', key: 'digestiveAmount', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.cv'), align: 'center', key: 'cv', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.cpa'), align: 'center', key: 'cpa', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.cvr'), align: 'center', key: 'cvr', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.vcv'), align: 'center', key: 'vcv', sortable: true, width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.playCount'), align: 'center', sortable: true, key: 'playCount', width: '100'},
        {title: this.$t('cpmCreativeReport.table.headers.firstQuartileCount'), align: 'center', sortable: true, key: 'firstQuartileCount', width: '150'},
        {title: this.$t('cpmCreativeReport.table.headers.midpointCount'), align: 'center', sortable: true, key: 'midpointCount', width: '150'},
        {title: this.$t('cpmCreativeReport.table.headers.thirdQuartileCount'), align: 'center', sortable: true, key: 'thirdQuartileCount', width: '150'},
        {title: this.$t('cpmCreativeReport.table.headers.completeCount'), align: 'center', sortable: true, key: 'completeCount', width: '150'},
        {title: this.$t('cpmCreativeReport.table.headers.cpcv'), align: 'center', sortable: true, key: 'cpcv', width: '100'}
      ],
      creativeReport: [],
      page: undefined, // 現在の表示ページ
      tmpPage: undefined,
      perPage: 100, // 1ページの表示件数
      defaultPerPage: 100,
      totalPage: undefined, // トータルページ数
      count: 0, // 総件数
      isMobile: false,
      errorMessage: undefined,
      warnDlg: {
        'text-h5': '',
        msg: '',
        maxWidth: 300,
        isOpen: false
      },
      preview: '',
      hoverDialogFlag: false,
      hoverVideoFlag: false,
      hoverIndex: null,
      previewImage: '',
      previewMovie: '',
      description: '',
      dialog: false,
      dialogWidth: 0,
      image_more_src: require(`../../public/imgs/outline_search_black_18dp.png`)
    }
  },
  methods: {
    ...mapActions('cpmCreativeReport', ['getFilterList', 'getCreativeReport', 'getCsvDownload']),
    ...mapActions('headerParam', ['setHeaderParamAgencyAdvertiser']),
    initialize: function () {
      this.initializeDateTimeRanges()

      this.initializeFilter().then((flg) => {
        if (flg) {
          this.previewCreativeReportList()
        }
      })
      this.setHeaderParamAgencyAdvertiser({ agencyId: this.agencyId, advertiserId: this.advertiserId })
    },
    initializeDateTimeRanges: function () {
      // 今日
      const today = moment().startOf('day').toDate()
      // 昨日
      const yesterday = moment(today).add(-1, 'days').startOf('day').toDate()
      // 当日から一週間前
      const lastWeekAgo = moment(today).add(-6, 'days').toDate()
      // 昨日から一週間前
      const lastWeekDayAgo = moment(yesterday).add(-6, 'days').toDate()
      // 月初
      const monthFirst = moment(today).startOf('month').toDate()
      // 先月末
      const lastMonthEnd = moment(today).startOf('month').add(-1, 'days').toDate()
      // 先月月初
      const lastMonthFirst = moment(lastMonthEnd).startOf('month').toDate()
      // 30日前
      const day30ago = moment(today).add(-29, 'days').toDate()
      // 半年前（厳密な半年ではないが、代理店画面と合わせた）
      const halfYearDay = moment(today).add(-6, 'month').add(1, 'days').toDate()
      this.ranges = {
        [this.$t('commons.filter.calendar.today')]: [today, today],
        [this.$t('commons.filter.calendar.yesterday')]: [yesterday, yesterday],
        [this.$t('commons.filter.calendar.lastWeekAgo')]: [lastWeekAgo, today],
        [this.$t('commons.filter.calendar.lastWeekDayAgo')]: [lastWeekDayAgo, yesterday],
        [this.$t('commons.filter.calendar.day30ago')]: [day30ago, today],
        [this.$t('commons.filter.calendar.halfYearDay')]: [halfYearDay, today],
        [this.$t('commons.filter.calendar.thisMonth')]: [monthFirst, today],
        [this.$t('commons.filter.calendar.thisMonthYesterday')]: [monthFirst, yesterday],
        [this.$t('commons.filter.calendar.lastMonth')]: [lastMonthFirst, lastMonthEnd]
      }
      this.maxDate = today
      // 代理店画面と合わせて半年前の1日まで選択可能とした
      this.minDate = moment(halfYearDay).startOf('month').toDate()
      // 初期選択（引数がなければ当月とする）
      let startDate = this.$route.query.from ? moment(this.$route.query.from, 'YYYYMMDD').toDate() : monthFirst
      let endDate = this.$route.query.to ? moment(this.$route.query.to, 'YYYYMMDD').toDate() : today
      this.dateRange = { startDate: startDate, endDate: endDate }
      this.commitedateRange = { startDate: startDate, endDate: endDate }
    },
    createUrlParameter: function () {
      const newQuery = {};
      const currentQuery = { ...this.$route.query };

      // 2. 各条件に基づいて、更新するパラメータをオブジェクトに追加
      if (Object.keys(this.campaignList).length !== this.commiteCampaignIds.length && this.commiteCampaignIds.length > 0) {
        newQuery.cIds = this.commiteCampaignIds.join(',');
      } else if (this.commiteCampaignIds.length === 0) {
        newQuery.cIds = undefined;
      }

      // creativeSizeId
      if (Object.keys(this.creativeSizeList).length !== this.commiteCreativeSizeIds.length && this.commiteCreativeSizeIds.length > 0) {
        newQuery.sIds = this.commiteCreativeSizeIds.join(',');
      } else if (this.commiteCreativeSizeIds.length === 0) {
        newQuery.sIds = undefined;
      }

      // creativeTypeId
      if (Object.keys(this.creativeTypeList).length !== this.commiteCreativeTypeIds.length && this.commiteCreativeTypeIds.length > 0) {
        newQuery.tIds = this.commiteCreativeTypeIds.join(',');
      } else if (this.commiteCreativeTypeIds.length === 0) {
        newQuery.tIds = undefined;
      }

      // 計測期間
      if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
        newQuery.from = this.formatParameterDate(this.dateRange[0]);
        newQuery.to = this.formatParameterDate(this.dateRange[1]);
      } else {
        newQuery.from = undefined;
        newQuery.to = undefined;
      }

      // クリエイティブ名
      if (this.commiteCreativeName) {
        newQuery.c = this.commiteCreativeName;
      } else {
        newQuery.c = undefined;
      }

      // ページ番号
      if (this.page) {
        newQuery.p = this.page;
      } else {
        newQuery.p = undefined;
      }

      // 1ページの表示件数
      if (this.perPage !== this.defaultPerPage) {
        newQuery.pc = this.perPage;
      } else {
        newQuery.pc = undefined;
      }

      // ソート
      if (this.pagination.sortBy && this.pagination.sortBy.length > 0) {
        newQuery.sk = this.pagination.sortBy[0].key;
        newQuery.sd = this.pagination.sortBy[0].order === 'desc' ? 'true' : 'false';
      } else {
        newQuery.sk = undefined;
        newQuery.sd = undefined;
      }

      this.$router.replace({
        path: this.$route.path,
        query: { ...currentQuery, ...newQuery }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Router replace error:', err);
        }
      });
    },
    // フィルター部分の初期化処理
    initializeFilter: async function () {
      const jwtToken = this.$store.getters['auth/jwtToken']
      const agencyId = this.agencyId
      const advertiserId = this.advertiserId
      let flg = false

      // 後続処理でレポートを取得したいのでこの処理が終わるまで後続処理を待つ
      await this.getFilterList({
        privateCode: process.env.ProjectCode,
        agencyId: agencyId,
        advertiserId: advertiserId,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.errorMessage = undefined
          if (!result) {
            // 表示するデータがない場合
            this.campaignList = []
            this.creativeTypeList = []
            this.creativeSizeList = []
            return flg
          }
          // Select ボックスの初期値を設定
          this.campaignList = result.campaignList
          this.creativeTypeList = result.creativeTypeList
          this.creativeSizeList = result.creativeSizeList
          // キャンペーンの選択選択状態をハンドリングする
          this.setInitializeParameter()
          // キャンペーンは選択必須のため初期選択されていなければ後続処理は行わない
          if (this.commiteCampaignIds.length > 0) {
            flg = true
          }
        })
        .catch((err) => {
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })

      return flg
    },
    setInitializeParameter: function () {
      this.initializeCampaignIds()
      this.initializeCreativeTypeIds()
      this.initializeCreativeSizeIds()
      this.initializeCreativeName()
      this.initializeSortKey()
    },
    initializeCampaignIds: function () {
      let cIds = []
      if (this.campaignIdsComputed.length > 0) {
        cIds = this.campaignIdsComputed
      } else {
        cIds = this.$route.query.cIds ? String(this.$route.query.cIds).split(',') : null
      }

      if (cIds) {
        let numberIds = []
        cIds.forEach((cId) => {
          numberIds.push(Number(cId))
        })
        this.campaignIdsComputed = numberIds
        this.commiteCampaignIds = numberIds
      } else {
        let ids = []
        this.campaignList.forEach(function (item) {
          ids.push(item['campaignId'])
        })
        this.campaignIdsComputed = ids
        this.commiteCampaignIds = ids
      }
    },
    initializeCreativeTypeIds: function () {
      let tIds = []
      if (this.creativeTypeIdsComputed.length > 0) {
        tIds = this.creativeTypeIdsComputed
      } else {
        tIds = this.$route.query.tIds ? String(this.$route.query.tIds).split(',') : null
      }
      // let initSelectcampaignIds = []
      if (tIds) {
        let numberIds = []
        tIds.forEach((tId) => {
          numberIds.push(Number(tId))
        })
        this.creativeTypeIdsComputed = numberIds
        this.commiteCreativeTypeIds = numberIds
      } else {
        let ids = []
        this.creativeTypeList.forEach(function (item) {
          ids.push(item['creativeTypeId'])
        })
        this.creativeTypeIdsComputed = ids
        this.commiteCreativeTypeIds = ids
      }
    },
    initializeCreativeSizeIds: function () {
      let sIds = []
      if (this.creativeSizeIdsComputed.length > 0) {
        sIds = this.creativeSizeIdsComputed
      } else {
        sIds = this.$route.query.sIds ? String(this.$route.query.sIds).split(',') : null
      }
      if (sIds) {
        let numberIds = []
        sIds.forEach((sId) => {
          numberIds.push(Number(sId))
        })
        this.creativeSizeIdsComputed = numberIds
        this.commiteCreativeSizeIds = numberIds
      } else {
        let ids = []
        this.creativeSizeList.forEach(function (item) {
          ids.push(item['creativeSizeId'])
        })
        this.creativeSizeIdsComputed = ids
        this.commiteCreativeSizeIds = ids
      }
    },
    initializeCreativeName: function () {
      if (this.$route.query.c) {
        const cName = this.$route.query.c
        this.creativeName = cName
        this.commiteCreativeName = cName
      }
    },
    initializeSortKey: function () {
      if (this.$route.query.sk) {
        this.pagination.sortBy = this.$route.query.sk
        this.pagination.descending = this.parseStrToBoolean(this.$route.query.sd)
      }
    },
    parseStrToBoolean: function(str) {
      if (str === 'true') {
        return true
      } else {
        return false
      }
    },
    warnDialog: function (title, message) {
      this.warnDlg.headline = title
      this.warnDlg.msg = message
      this.warnDlg.isOpen = true
    },
    clickCampaignList: function () {
      this.$router.push(`/campaignList/${this.agencyId}/${this.advertiserId}`)
    },
    // 検索ボタン押下イベント
    search: function () {
      if (this.campaignIdsComputed.length === 0 || this.creativeTypeIdsComputed.length === 0 || this.creativeSizeIdsComputed.length === 0) {
        this.warnDialog('確認', '条件が指定されていません')
        return
      }

      this.commiteCampaignIds = this.campaignIdsComputed.slice()
      this.commiteCreativeSizeIds = this.creativeSizeIdsComputed.slice()
      this.commiteCreativeTypeIds = this.creativeTypeIdsComputed.slice()
      this.commiteCreativeName = this.creativeName
      this.commitedateRange = this.dateRange
      this.page = 1
      this.previewCreativeReportList()
    },
    clickDownload: function () {
      this.isSearching = false
      this.isCsvDownload = false

      const jwtToken = this.$store.getters['auth/jwtToken']
      const agencyId = this.agencyId
      const advertiserId = this.advertiserId
      const from = this.formatParameterDate(this.commitedateRange.startDate)
      const to = this.formatParameterDate(this.commitedateRange.endDate)
      const campaignIds = this.createParameter(this.commiteCampaignIds, this.campaignList)
      const creativeTypeIds = this.createParameter(this.commiteCreativeTypeIds, this.creativeTypeList)
      const creativeSizeIds = this.createParameter(this.commiteCreativeSizeIds, this.creativeSizeList)
      const creativeName = this.commiteCreativeName
      const sortKey = this.pagination.sortBy
      const sortDesc = this.pagination.descending

      const charset = 'Shift_JIS'

      this.getCsvDownload({
        privateCode: process.env.ProjectCode,
        agencyId: agencyId,
        advertiserId: advertiserId,
        from: from,
        to: to,
        campaignIds: campaignIds,
        creativeTypeIds: creativeTypeIds,
        creativeSizeIds: creativeSizeIds,
        creativeName: creativeName,
        sortKey: sortKey,
        sortDesc: sortDesc,
        charset: charset,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.errorMessage = undefined
        })
        .catch((err) => {
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
        .then(() => {
          this.isSearching = false
          this.isCsvDownload = true
        })
    },
    // ソートイベント
    changeSort(column) {
      if (!this.pagination.isSorting) {
        this.pagination.isSorting = true
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
        this.page = 1
        this.previewCreativeReportList().then((then) => {
          // レポートの描画が終ったらソートを有効にする
          this.createUrlParameter()
          this.pagination.isSorting = false
        })
      }
    },
    createParameter(params, list) {
      if (Object.keys(list).length !== params.length) {
        return params.join(',')
      }
    },
    previewCreativeReportList: async function () {
      this.isSearching = true
      this.isCsvDownload = false

      const jwtToken = this.$store.getters['auth/jwtToken']
      const agencyId = this.agencyId
      const advertiserId = this.advertiserId
      const from = this.formatParameterDate(this.commitedateRange.startDate)
      const to = this.formatParameterDate(this.commitedateRange.endDate)
      const campaignIds = this.createParameter(this.commiteCampaignIds, this.campaignList)
      const creativeTypeIds = this.createParameter(this.commiteCreativeTypeIds, this.creativeTypeList)
      const creativeSizeIds = this.createParameter(this.commiteCreativeSizeIds, this.creativeSizeList)
      const creativeName = this.commiteCreativeName
      const sortKey = this.pagination.sortBy
      const sortDesc = this.pagination.descending
      let page = 1
      if (this.$route.query.p && this.page === undefined) {
        page = this.$route.query.p
      } else if (this.page) {
        page = this.page
      }
      let perPage = this.defaultPerPage
      if (this.$route.query.pc) {
        perPage = this.$route.query.pc
      } else if (this.perPage) {
        perPage = this.perPage
      }

      await this.getCreativeReport({
        privateCode: process.env.ProjectCode,
        agencyId: agencyId,
        advertiserId: advertiserId,
        from: from,
        to: to,
        campaignIds: campaignIds,
        creativeTypeIds: creativeTypeIds,
        creativeSizeIds: creativeSizeIds,
        creativeName: creativeName,
        sortKey: sortKey,
        sortDesc: sortDesc,
        page: page,
        perPage: perPage,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.errorMessage = undefined
          if (!result) {
            // 表示するデータがない場合
            this.totalReport = []
            this.creativeReport = []
            this.isCsvDownload = false
            return
          }
          this.totalReport = result.totalReport !== null ? [result.totalReport] : []
          this.creativeReport = result.creativeReport.length > 0 ? result.creativeReport : []
          this.totalPage = Number(result.totalPage)
          this.page = Number(result.page)
          this.perPage = Number(result.perPage)
          this.count = Number(result.count)

          if (result.creativeReport.length > 0) {
            this.isCsvDownload = true
            this.totalCreative = result.creativeReport.length
          }
          // URLにパラメータを付与
          this.createUrlParameter()
        })
        .catch((err) => {
          console.log(err)
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
        .then(() => {
          this.isSearching = false
        })
    },
    previewDialog: function (index, previewImage, creativeSize, description) {
      this.hoverDialogFlag = true
      this.hoverIndex = index
      this.previewImage = previewImage
      this.dialog = true
      let size = creativeSize.split('x')
      let widthNumber = Number(size[0]) + 20
      this.dialogWidth = String(widthNumber)
      this.description = description !== undefined ? description : ''
    },
    previewResizeDialog: function (index, previewImage, creativeSize) {
      this.description = ''
      this.hoverDialogFlag = true
      this.hoverIndex = index
      this.previewImage = previewImage
      this.dialog = true
      let size = creativeSize.split('x')
      let w = Number(size[0])
      let h = Number(size[1])
      let maxWidth = 1024
      let maxHeight = 600
      if (w > h) {
        if (w > maxWidth) {
          h = (maxWidth * h) / w
          w = maxWidth
        }
      } else {
        if (h > maxHeight) {
          w = (maxHeight * w) / h
          h = maxHeight
        }
      }

      let widthNumber = Number(w) + 20
      this.dialogWidth = String(widthNumber)
    },
    previewCkickOpenWindow: function (index, previewMovie) {
      this.hoverVideoFlag = true
      this.hoverIndex = index
      this.previewMovie = previewMovie
      window.open(previewMovie, null)
    },
    convertDynamicCreative: function (scriptTag) {
      // Dynamic クリエイティブのプレビュータグはスクリプトタグで生成されている為、
      // プレビュー時はバックエンド側で生成したiframeタグのみを抽出する
      const previewTagStartPos = 47
      const previewTagEndPos = -12
      return scriptTag.slice(previewTagStartPos, previewTagEndPos)
    },
    onResize: function () {
      const elements = document.getElementsByClassName('nowrap')
      elements.forEach(function (el) {
        el.setAttribute('style', 'white-space:nowrap;')
      })
      // MultiSelect で長いクリエイティブ名やクリエイティブ種別を表示するとき UI の崩れを防止するため
      const campaignSelect = document.getElementsByClassName('v-select__selections')
      campaignSelect.forEach(element => {
        element.style.width = '90%'
      })

      if (window.innerWidth < 960) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    formatDisplayDate(value) {
      return this.formatDate(value, 'YYYY/MM/DD')
    },
    formatParameterDate(value) {
      return this.formatDate(value, 'YYYYMMDD')
    },
    formatDate(value, format) {
      return moment(value).format(format)
    },
    pageChange: function (pageNumber) {
      this.page = pageNumber
      this.previewCreativeReportList()
    },
    isVideoAdsReport: function(videoAdsData) {
      if (videoAdsData === null) {
        return false
      }
      return true
    },
    isNotEmptyVideoAds: function(videoAdsData, columnName) {
      if (videoAdsData === null) {
        return false
      }
      if (videoAdsData[columnName] === null) {
        return false
      }
      return true
    }
  },
  computed: {
    campaignIdsComputed: {
      get() {
        return this.campaignIds
      },
      set(value) {
        this.campaignIds = value
      }
    },
    creativeTypeIdsComputed: {
      get() {
        return this.creativeTypeIds
      },
      set(value) {
        this.creativeTypeIds = value
      }
    },
    creativeSizeIdsComputed: {
      get() {
        return this.creativeSizeIds
      },
      set(value) {
        this.creativeSizeIds = value
      }
    },
    isDisabledBtn: function () {
      if (this.isSearching) {
        return true
      }
      return false
    },
    isDisabledCsvDownloadBtn: function () {
      if (this.isDisabledBtn) {
        return true
      }
      if (!this.isCsvDownload) {
        return true
      }
      return false
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    next()
  },
  mounted: function () {
    this.initialize()
  }
}
</script>
<style scoped>
.calendars::after {
  content: '';
  display: block;
  clear: both;
}
.slot {
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.v-label {
  font-size: 12px !important;
}
.v-btn {
  margin: 6px;
}
</style>
